import { Component, OnInit } from '@angular/core';
import { AppUserInfoFacade } from './app-user-info.facade';

@Component({
  selector: 'sd-portal-app-user-info',
  templateUrl: './app-user-info.component.html',
  styleUrls: ['./app-user-info.component.scss']
})
export class AppUserInfoComponent implements OnInit {
  facade: AppUserInfoFacade;

  constructor(private readonly appUserInfoFacade: AppUserInfoFacade) {}

  ngOnInit() {
    this.facade = this.appUserInfoFacade;
  }
}
